/**
 * @deprecated
 * React Router v6への移行のためのものです
 * v6移行時: useRouteMatch → useMatch に変更
 */
import React, {ComponentType} from 'react'
import {useRouteMatch, useLocation, useHistory} from 'react-router-dom'
import type {History, Location} from 'history'
import type {match as Match} from 'react-router-dom'

export interface RouteComponentProps<Params extends {[K in keyof Params]?: string} = object> {
  history: History
  location: Location
  match: Match<Params>
}

const withRouterLegacy = <P extends RouteComponentProps>(Component: ComponentType<P>) => {
  const Wrapper = React.forwardRef<unknown, Omit<P, keyof RouteComponentProps>>((props, ref) => {
    const history = useHistory()
    const location = useLocation()
    const match = useRouteMatch()
    return <Component {...(props as unknown as P)} ref={ref} history={history} location={location} match={match} />
  })
  Wrapper.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`
  return Wrapper
}

export default withRouterLegacy
